import { SwipeableDrawer as SwipeableDrawerBase } from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
  disableRestoreFocus?: boolean;
  hasFullHeight?: boolean;
  heightOffset?: number;
  backgroundColor?: string;
  keepMounted?: boolean;
  children: React.ReactNode;
};

export function SwipeableDrawer({
  children,
  hasFullHeight,
  heightOffset = 0,
  backgroundColor,
  keepMounted = true,
  ...rest
}: Props) {
  const heightOffsetWithUnit = `${heightOffset}px`;

  const heightStyle = hasFullHeight
    ? `calc(100dvh - ${heightOffsetWithUnit})`
    : "auto";

  return (
    <SwipeableDrawerBase
      anchor="bottom"
      onOpen={() => {}} // required prop, but we don't need to do anything on open
      sx={{
        "& .MuiDrawer-paper": {
          height: heightStyle,
          backgroundColor,
        },
      }}
      ModalProps={{
        keepMounted,
      }}
      {...rest}
    >
      {/* puller */}
      <div className="mx-auto -mt-4 mb-4 h-1 w-10 shrink-0 rounded-full bg-stroke-neutral-soft" />
      {children}
    </SwipeableDrawerBase>
  );
}
